export const customColors = {
  mainColor: "#225DA4",
  mainMessageBlue: "#007AFF",
  warningColor: "#F83737",
  selector: "#E3EAF3",
  lightGray: "#EFEFEF",
  grayText: "#9A9EA5",
  lightGrayText: "#8d8d8d",
  icon: "#71839B",
  text: "#272727",
  infoText: "#707680",
  gridHeaderText: "#676767",
  error: "#FF472E",
  success: "#02EE6A",
  black: "#111111",
  white: "#fff",
  lightGrayBackground: "#E5E5E5",
  unactive: "#DFDFDF",
  header: {
    grayBack: "#F7F7F8",
  },
  info: {
    background: "#F6F8FF",
    label: "#71839B",
    text: "#424242",
  },
  status: {
    referred: {
      color: "#0085FF",
      backgroundColor: "#0085FF1A",
      "&:hover": {
        backgroundColor: "#0085FF2A",
      },
    },
    acknowledged: {
      color: "#00C1CA",
      backgroundColor: "#E8FEFF",
      "&:hover": {
        backgroundColor: "#D8EEEF",
      },
    },
    contacted: {
      color: "#514EF3",
      backgroundColor: "#ECECFE",
      "&:hover": {
        backgroundColor: "#CCCCCE",
      },
    },
    scheduled: {
      color: "#FF7A00",
      backgroundColor: "#FEF8EC",
      "&:hover": {
        backgroundColor: "#EEE8DC",
      },
    },
    unsuccessful: {
      color: "#FF472E",
      backgroundColor: "#FFEDEA",
      "&:hover": {
        backgroundColor: "#EFDDDA",
      },
    },
    completed: {
      color: "#1DA633",
      backgroundColor: "#EAFBE7",
      "&:hover": {
        backgroundColor: "#DAEBD7",
      },
    },
  },
};
